import { Routes, Route } from "react-router-dom";
import { useState, useEffect } from 'react';
import './App.css';
import Header from "./components/Header";
import Footer from "./components/Footer";
import MovieItem from "./pages/MovieItem";
import MovieList from "./pages/MovieList";
import Search from "./pages/Search";
import PageNotFound from "./pages/PageNotFound";


function App() {
  const [darkMode, setDarkMode] = useState(JSON.parse(localStorage.getItem('darkMode')) || true);

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));

  }, [darkMode]);

  return (
    <div className={`App ${darkMode ? "dark" : ""}`}> 
      <div className="dark:bg-slate-800">
        <Header darkMode={darkMode} setDarkMode={setDarkMode} />  
        <main className="min-h-90vh max-w-7xl mx-auto p-3">        
          <Routes>
              <Route path="" element={<MovieList apiPath="now_playing" title="Home" />}></Route>
              <Route path="movie/:id" element={<MovieItem />}></Route>
              <Route path="movies/popular" element={<MovieList apiPath="popular" title="Popular" />}></Route>
              <Route path="movies/top" element={<MovieList apiPath="top_rated" title="Top Rated" />}></Route>
              <Route path="movies/upcoming" element={<MovieList apiPath="upcoming" title="Upcoming" />}></Route>
              <Route path="/search" element={<Search />}></Route>
              <Route path="*" element={<PageNotFound title="404 Not Found" />}></Route>
          </Routes>  
        </main>      
        <Footer />
      </div>    
    </div>
  );
}

export default App;
